import _                     from 'underscore';
import React, { FC }         from 'react';
import { Image, ImageProps } from 'semantic-ui-react';

// @ts-ignore
import whiteLogo          from '../../../_assets/images/branding/corval-logo-white.svg';
// @ts-ignore
import blueLogo           from '../../../_assets/images/branding/corval-logo-monocolor-blue.svg';
// @ts-ignore
import blueTextColorLogo  from '../../../_assets/images/branding/corval-logo-rgb.svg';
// @ts-ignore
import whiteTextColorLogo from '../../../_assets/images/branding/corval-logo-rgb-white.svg';

// @ts-ignore
import whiteHexLogo from '../../../_assets/images/branding/corval-logo-white-hex.svg';
// @ts-ignore
import blueHexLogo  from '../../../_assets/images/branding/corval-logo-monocolor-blue-hex.svg';
// @ts-ignore
import colorHexLogo from '../../../_assets/images/branding/corval-logo-rgb-hex.svg';

export enum CorvalLogoVersions {
	BLUE_TEXT_MONO       = 'All blue text version',
	WHITE_TEXT_MONO      = 'All white text version',
	BLUE_TEXT_COLORIZED  = 'Blue text with colorized hex "o" version',
	WHITE_TEXT_COLORIZED = 'White text with colorized hex "o" version',
	WHITE_HEX_LOGO       = 'White hex "o" logo version',
	BLUE_HEX_LOGO        = 'Blue hex "o" logo version',
	COLOR_HEX_LOGO       = 'Colorized hex "o" logo version',
}

export interface CorvalLogoProps extends ImageProps {
	type?: CorvalLogoVersions,
	width?: number,
	
	[ additionalImageProps: string ]: any
}

const logoTypes = {
	[ CorvalLogoVersions.BLUE_TEXT_MONO ]:       blueLogo,
	[ CorvalLogoVersions.WHITE_TEXT_MONO ]:      whiteLogo,
	[ CorvalLogoVersions.BLUE_TEXT_COLORIZED ]:  blueTextColorLogo,
	[ CorvalLogoVersions.WHITE_TEXT_COLORIZED ]: whiteTextColorLogo,
	[ CorvalLogoVersions.WHITE_HEX_LOGO ]:       whiteHexLogo,
	[ CorvalLogoVersions.BLUE_HEX_LOGO ]:        blueHexLogo,
	[ CorvalLogoVersions.COLOR_HEX_LOGO ]:       colorHexLogo,
}

const defaultProps: CorvalLogoProps = {
	type:  CorvalLogoVersions.WHITE_TEXT_COLORIZED,
	width: null,
}

const CorvalLogo: FC<CorvalLogoProps> = ( props ) => {
	let { type, width, ...imageProps } = props,
	    style                          = _.isNull( width ) ? {} : { width };
	
	if( width ){
		imageProps.style = { ...( imageProps.style ?? {} ), ...style };
	}
	
	return ( <Image src={ logoTypes[ type ] } { ...imageProps }/> );
};

CorvalLogo.defaultProps = defaultProps;

export { CorvalLogo }
